import { ViewData } from '../../../model/view.data';
import { INC_EXC_KIND } from '../../../model/enums';
import { ChronocodeVO } from '../chronocode.vo';
import { FreeDataVO } from '../freedata.vo';
import { FreedataValueVO } from '../freedatavalue.vo';
import { IncExcContentObj } from './incex.content.obj';
import { Model } from '../../../model/model';

/** encapsulation d'un ChronocodeVO (level 1) ou d'un freedataVO  */
export class IncExcMainObj {
  // portée de l'objet, un FD
  public chrono: ChronocodeVO = null; // le chrono est forcément level 1
  public freedata: FreeDataVO = null;

  public source: ChronocodeVO | FreeDataVO; // l'objet porteur
  public kind: INC_EXC_KIND = null; // selon le type, CHRO ou FD

  /**
   * constructeur composite
   * @param chrono 1
   * @param freedata 2
   */
  public constructor(chrono: ChronocodeVO = null, freedata: FreeDataVO = null) {
    if (chrono) {
      this.chrono = chrono;
      this.source = chrono;
      this.kind = INC_EXC_KIND.CHRO;
    } else if (freedata) {
      this.freedata = freedata;
      this.source = freedata;
      this.kind = INC_EXC_KIND.FD;
    }
  }

  /** accesseur sur le code (véritable) de l'objet source, pour rendu dans la liste maître */
  public get code(): string {
    return this.source.code;
  }

  /** accesseur sur le libellé traduit */
  public get label(): string {
    return this.source.trsLabel;
  }

  /** accesseur composite */
  public get fullLabel(): string {
    return this.label + ' (' + this.code + ')';
  }

  /** accesseur sur le code pour définition d'un incexc : CHRONO pour les chronos, code du FD pour les FreeDatas */
  public get incexcMasterCode(): string {
    let result: string = this.code;
    if (this.kind === INC_EXC_KIND.CHRO) {
      result = ViewData.CHRONO;
    }
    return result;
  }

  /** accesseur sur le kind en mode string (pour sort) */
  public get kindStr(): string {
    return this.kind.toString();
  }

  private _contents: IncExcContentObj[] = null;
  /** accesseur sur les enfants */
  public get contents(): IncExcContentObj[] {
    if (!this._contents) {
      this.buildContents();
    }
    return this._contents;
  }

  private _contentsMap: Map<string, IncExcContentObj> = null;
  /** accesseur sur les enfants en mode map, code = IncExcContentObj */
  public get contentsMap(): Map<string, IncExcContentObj> {
    if (!this._contentsMap) {
      this.buildContents();
    }
    return this._contentsMap;
  }

  /** construction de la structure enfant */
  private buildContents(): void {
    let contents: IncExcContentObj[];
    if (!!this.chrono) {
      const chronos: ChronocodeVO[] = Model.getInstance().chronocodeEngine.flatChronoFamily(this.chrono);
      contents = chronos.map((vvo: ChronocodeVO) => new IncExcContentObj(this, vvo));
    } else if (!!this.freedata) {
      contents = this.freedata.getValuesVO().map((vvo: FreedataValueVO) => new IncExcContentObj(this, null, vvo));
    }
    this._contents = contents;
    this._contentsMap = new Map(contents.map((ieco) => [ieco.code, ieco]));
  }
}
